import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import PartnerAccountsList from './PartnerAccountsList'
import CreatePartnerAccount from './PartnerAccountForms/CreatePartnerAccount'
import EditPartnerAccount from './PartnerAccountForms/EditPartnerAccount'

import { getSelfAccounts, clearSelfAccounts } from '../../../modules/actions/selfAccounts'
import { selectedPartnershipSelector } from '../../../modules/selectors/partnerships'

import useCommonStyles from '../../../styles/common/listPage'

const PartnerAccounts = () => {
  const commonClasses = useCommonStyles()

  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { rights_holder: rightsHolderId } = useSelector(selectedPartnershipSelector)

  useEffect(() => {
    dispatch(
      getSelfAccounts({
        account_type: 'partner',
        parent_right_holder: rightsHolderId
      })
    )

    return () => {
      dispatch(clearSelfAccounts())
    }
  }, [dispatch, rightsHolderId])

  return (
    <>
      <div className={commonClasses.heading}>
        <h3 className={commonClasses.title}>{t('Partner Accounts')}</h3>
        <p>
          {t(
            'An account represents a sponsor or partner brand. Each account has its own team list allowing for client access to their own rights and campaigns only.'
          )}
        </p>
        <div className={commonClasses.formButtons}>
          <CreatePartnerAccount />
        </div>
      </div>
      <PartnerAccountsList />
      <EditPartnerAccount />
    </>
  )
}

export default PartnerAccounts
